import { createContext } from "react";
// const myPreferences = getPreferences();
export const StrategyContext = createContext({
    cashScripObject: undefined,
    setCashScripObject: (cashScripObject) => { },
});
export const OptionLegContext = createContext({
    selectedLegData: [],
    addOcLegData: (item) => { },
});
export const OverviewDashboardContext = createContext({
    scripObject: undefined,
    setScripObject: (scripObject) => { },
});
export const LoginContext = createContext({
    isLoggedIn: false,
    toggleLogin: (boolean) => { },
});
export const ReportHeightContext = createContext({
    reportHeightData: {},
    addReportData: (reportType, newData) => { },
});
export const PricePickerContext = createContext({
    picker: {
        price: 0,
        type: "market",
        modalToggleHideShow: false,
    },
    setPicker: (picker) => { },
});
export const DepthSnapToggleContext = createContext({
    depthToggle: {
        show20: false,
        toggleShowQuotes: false,
        fullHeighModal: "",
    },
    setDepthSnapToggleContext: (depthToggle) => { },
});
